export const copy = {
  label: 'Select your utility service class as shown on your utility bill',
};
